import React, { useEffect, useState } from 'react'
import AddProductCatalouge from '../components/AddProducts/AddProductCatalouge'
import HeaderTabLayout from '../components/HeaderTabLayout'
import Layout from '../components/Layout'
import { useProductCatalogue } from '../hooks/Features/useProductCatalogue'
import { isArray, ROUTES, uploadFilesToAws } from '../shared/constants'
import { Backdrop, CircularProgress } from '@material-ui/core'

function AddProductCatalogue({ catalog }) {
  const { addProductCatalogue, editProductCatalogue } = useProductCatalogue()
  const [progress, setProgress] = useState(false)
  const [productCatalogue, setProductCatalogue] = useState({
    image: '',
    name: '',
    description: '',
    active: true,
  })

  const handleProductCatelogue = async () => {
    let location = productCatalogue.image
    if (!isArray(location)) {
      location = await uploadFilesToAws(location)
    }
    if (catalog) {
      editProductCatalogue({
        ...productCatalogue,
        productCatalougeId: catalog._id,
        image: location,
      })
    } else {
      addProductCatalogue({
        name: productCatalogue.name,
        description: productCatalogue.description,
        image: location,
      })
    }
  }
  useEffect(() => {
    if (catalog) {
      setProductCatalogue({
        ...productCatalogue,
        image: catalog.image,
        name: catalog.name,
        description: catalog.description,
        active: catalog.active,
      })
    }
  }, [catalog])

  return (
    <Layout heading="Product Catalogue" heading2={catalog ? 'Edit' : 'Add'} url1={ROUTES.PRODUCT_CATALOGUE} none>
      <div>
        <HeaderTabLayout
          heading={`${catalog ? 'Edit' : 'Add'} Product Catalogue`}
          content={
            <AddProductCatalouge state={productCatalogue} setState={setProductCatalogue} setProgress={setProgress} />
          }
          addContent={handleProductCatelogue}
          redirect={ROUTES.PRODUCT_CATALOGUE}
          state={productCatalogue} setState={setProductCatalogue}         />
      </div>
    </Layout>
  )
}

export default AddProductCatalogue
